'use strict';

const RANGE_DEBOUNCE_MS = 700;

export default function Range({titleFrom = '', valueFrom = '', titleTo = '', valueTo = '', onChangeFrom, onChangeTo}) {

    const label_length = Math.max(titleFrom.length, titleTo.length)
    const custom_padding = label_length > 2 ? 40 + (label_length-2) * 5 : null // Для англ from

    const [from, setFrom] = React.useState(valueFrom || '');
    const [to, setTo] = React.useState(valueTo || '');
    const timerFrom = React.useRef(null);
    const timerTo = React.useRef(null);

    // Внешний сброс (clearFilters) — подтягиваем значения из пропсов.
    React.useEffect(() => { setFrom(valueFrom || ''); }, [valueFrom]);
    React.useEffect(() => { setTo(valueTo || ''); }, [valueTo]);
    React.useEffect(() => () => {
        if (timerFrom.current) clearTimeout(timerFrom.current);
        if (timerTo.current) clearTimeout(timerTo.current);
    }, []);

    const sendDebounced = (timerRef, setter, callback, value) => {
        setter(value);
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            const digits = (value || '').replace(/\D/g, "");
            callback && callback(digits);
        }, RANGE_DEBOUNCE_MS);
    };

    const handleChangeFrom = (value) => {
        sendDebounced(timerFrom, setFrom, onChangeFrom, value);
    }

    const handleChangeTo = (value) => {
        sendDebounced(timerTo, setTo, onChangeTo, value);
    }

    const valueFromFormatted = (from || '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    const valueToFormatted = (to || '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    return <React.Fragment>
        <div className="el-select__input">
            <input type="text"
                   value={valueFromFormatted}
                   style={custom_padding ? {paddingLeft: custom_padding} : {}}
                   onChange={(event) => handleChangeFrom(event.target.value)}
            />
            <label>{titleFrom}</label>
            <a role='button' className="el-select__input-clear"></a>
        </div>
        <div className="el-select__input">
            <input type="text"
                   value={valueToFormatted}
                   style={custom_padding ? {paddingLeft: custom_padding} : {}}
                   onChange={(event) => handleChangeTo(event.target.value)}
            />
            <label>{titleTo}</label>
            <a role='button' className="el-select__input-clear"></a>
        </div>
    </React.Fragment>
}
